import { Component } from '@angular/core';

@Component({
  selector: 'app-ipo',
  templateUrl: './ipo.component.html',
  styleUrls: ['./ipo.component.css']
})
export class IpoComponent {
  columnGroups = [
    [
      {
        title: 'Stalwart People Services India Limited',
        icon: 'assets/images/icons/apps.png',
        items: [
          { name: 'Draft Abridged Prospectus', url: 'assets/pdf/ipo/Draft-Abridged-Prospectus.pdf' },
          { name: 'Draft Red Herring Prospectus', url: 'assets/pdf/ipo/Draft-Red-Herring-Prospectus.pdf' },
          { name: 'DRHP Filing Advertisement', url: 'assets/pdf/ipo/DRHP-Filing-Advertisement.pdf' },
        ]
      },
      // {
      //   title: 'HDFC Bank',
      //   icon: 'assets/images/icons/merge.png',
      //   items: [
      //     'Savings Accounts',
      //     'Credit Cards',
      //     'Home Loans',
      //     'Vehicle Loans'
      //   ]
      // }
    ],
    // [
    //   {
    //     title: 'ICICI Bank',
    //     icon: 'assets/images/icons/account_tree.png',
    //     items: [
    //       'Net Banking',
    //       'iMobile Pay',
    //       'Wealth Management',
    //       'Demat Account'
    //     ]
    //   },
    //   {
    //     title: 'JPMorgan Chase',
    //     icon: 'assets/images/icons/money_bag.png',
    //     items: [
    //       'Investment Banking',
    //       'Asset Management',
    //       'Commercial Banking',
    //       'Private Banking'
    //     ]
    //   }
    // ],
    // [
    //   {
    //     title: 'Goldman Sachs',
    //     icon: 'assets/images/icons/join_right.png',
    //     items: [
    //       'Global Markets',
    //       'Consumer & Wealth Management',
    //       'Asset Management'
    //     ]
    //   },
    //   {
    //     title: 'Morgan Stanley',
    //     icon: 'assets/images/icons/apps.png',
    //     items: [
    //       'Institutional Securities',
    //       'Wealth Management',
    //       'Investment Management'
    //     ]
    //   }
    // ]
  ];

  expandedStates: { [key: string]: boolean } = {};

  toggleExpand(colIndex: number, cardIndex: number): void {
    const key = `${colIndex}_${cardIndex}`;
    const currentState = !!this.expandedStates[key];
    
    // If you only want one expanded per column:
    for (let i = 0; i < this.columnGroups[colIndex].length; i++) {
      this.expandedStates[`${colIndex}_${i}`] = false;
    }
    
    // Toggle the clicked one
    this.expandedStates[key] = !currentState;
  }
}
